import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Logged-out visitors can only browse the Community view (the front page,
// "/") -- every other route redirects there rather than rendering
// personal-library UI against no session.
const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;

  return children;
};

export default RequireAuth;
